// extracted by mini-css-extract-plugin
module.exports = {"main":"BaseLayout_main__2Z0hw","layout":"BaseLayout_layout__2eJwZ","rotating":"BaseLayout_rotating__SnMws"};